export const projects = [
  {
    id: "project1",
    title: "BLUEPRINT",
    img: "https://i.postimg.cc/wvLvp3PQ/blueprint.jpg",
    description:
      "Team Blueprint, a team of ASME NIT Rourkela, engages in research, innovation, and design. They utilize CAD software to create diverse models, subsequently manufacturing them through 3D printing technology. The team actively participates in the IAM3D competition as part of ASME Efest, showcasing their skills and expertise in engineering and design within the ASME community.",
  },
  {
    id: "project2",
    title: "BLUESTREAK",
    img: "https://i.postimg.cc/brPvNpfc/velomobile.jpg",
    description:
      "Bluestreak, a team within ASME at NIT Rourkela, is a dedicated team focused on research, analysis, and innovation. They specialize in designing human-powered vehicles from scratch, incorporating indigenous elements. Bluestreak actively participates in the eHPV competition at ASME Efest, showcasing their commitment to pushing the boundaries of human-powered vehicle design and contributing to the advancement of sustainable transportation solutions.",
  },
  {
    id: "project3",
    title: "BLUEBIRD",
    img: "https://i.postimg.cc/Bvd6k2hv/drone.jpg",
    description:
      "Bluebird, a team from ASME NIT Rourkela, specializes in CAD modeling and coding for virtual competitions. Their expertise extends to designing vehicles for diverse challenges, including autonomous vehicle competitions, lunar lander simulations, and ocean cleanup missions. Through innovation and technical prowess, Team Bluebird consistently participates in and excels at a variety of virtual events, showcasing their commitment to engineering excellence and problem-solving in the digital realm.",
  },
  {
    id: "project4",
    title: "OLD GUARD",
    img: "https://i.postimg.cc/9f40LLYS/old-guard.jpg",
    description:
      "Engineers, like other professionals, need strong communication skills in both speaking and writing. The Oral Competition, supported by the ASME Old Guard Committee, underscores the importance of effective oral presentations. The committee's annual contributions and volunteer efforts drive this program, benefiting engineering students and early career professionals, ultimately enhancing the engineering profession.",
  },
];

export const events = [
  {
    id: "event1",
    title: "ASME EFX",
    img: "https://i.postimg.cc/VLK9LnhG/ASME-News-e-Fx-New-Locations-hero.jpg",
    description:
      "ASME EFx events inject vitality into local communities with intimate, in-person gatherings you host. These thematic events offer a rich platform for students and early-career engineers, featuring technical programming, career development, and social activities. Local competitions, aligned with E-Fest challenges, expose participants to the e-Human Powered Vehicle Challenge, Student Design Competition, Oral Competition, Poster Competition, Elevator Pitch Competition, Environmental Systems Division Competition, and Innovative Additive Manufacturing 3D Competition. Custom local competitions, promoting teamwork and skill enhancement, are encouraged. Interactive workshops cover technical and soft skills, preparing students for post-graduation workforce entry. Networking opportunities connect participants with speakers, peers, faculty, and potential employers, fostering a vibrant engineering celebration.",
  },
  {
    id: "event2",
    title: "E-FESTS",
    img: "https://i.postimg.cc/Ls101xK6/hero-inaguralefdigital.jpg",
    description:
      'ASME Engineering Festivals (E-Fests) bring together students and emerging engineers worldwide in a dynamic digital space. Immerse yourself in innovation, enhance your resume, engage with prospective employers, partake in exciting digital competitions, and launch your career. Embrace the ethos of "innovate, create, compete, celebrate" through E-Fests, our premier all-virtual events: E-Fest Careers and E-Fest Digital. Join the global community to celebrate the essence of engineering in a vibrant and transformative digital experience.',
  },
  {
    id: "event3",
    title: "MENTORING",
    img: "https://i.postimg.cc/DwDM0tNM/Mentor-750x320.png",
    description:
      "ASME's career advice and mentoring go beyond conventional guidance, connecting aspiring engineers with seasoned professionals who share firsthand insights into post-graduate work realities. Engage in meaningful conversations, ask questions, and build your resume while gaining valuable perspectives from practicing engineers in today's dynamic workforce.",
  },
  {
    id: "event4",
    title: "WORKSHOPS",
    img: "https://i.postimg.cc/kgDHnnTS/Web-Ad-Pages-HR-Hero.png",
    description:
      "ASME's interactive workshops and sessions provide a dynamic learning platform for emerging engineers. Engage in collaborative experiences with hands-on software demos and professional development workshops. These sessions are designed to help you build a robust resume and skill set, offering valuable insights to navigate the early stages of your career successfully. Excel as a new engineer with the practical knowledge gained from these interactive and enriching opportunities.",
  },
];

export const achievements = [
  {
    id: "8",
    title: "ASME E-HPVC",
    year: "2022",
    right: false,
    img: "https://i.postimg.cc/02NLCqWb/images.png",
    description:
      "Carrying forward our rich legacy, Bluestreak 9.0, a team of 24 enthusiastic members from ASME NITR had an eye-catching victory in ASME E-HPVC by securing 2nd Rank all over the world and 1st in India in Critical Design Report and 3rd Rank globally and 1st in India in Innovation Report.",
  },
  {
    id: "7",
    title: "ASME E Fest",
    year: "2021",
    right: true,
    img: "https://i.postimg.cc/vZYcc2pr/pngkey-com-south-america-png-2014643.png",
    description:
      "Bluestreak 8.0, a team of 12 members from ASME NITR, participated in ASME E Fest and out of 79 tough teams, the team stamped its victory by securing 1st in India and 3rd Rank globally in CDR (Critical Design Report) Event.",
  },
  {
    id: "6",
    title: "ASME E Fest ASIA PACIFIC, VIT Vellore",
    year: "2019",
    right: false,
    img: "https://i.postimg.cc/02dz51H5/c6c2e9022f25f404fe108a4cfefab222.jpg",
    description:
      "Bluestreak 6.0, the team took part in ASME E Fest ASIA PACIFIC in March 2019 at VIT, Vellore and had a remarkable success by securing 9th in the Endurance race and a notable overall 13th position among 50 participating teams.",
  },
  {
    id: "5",
    title: "HPVC ASIA PACIFIC",
    year: "2017",
    right: true,
    img: "https://i.postimg.cc/02NLCqWb/images.png",
    description:
      "Continuing the excellence saga, the team got 20th spot in men's Endurance race and 24th in female Drag race out of 43 teams, and after counting technical score, the team bagged overall 24th position in HPVC ASIA PACIFIC 2017.",
  },
  {
    id: "4",
    title: "HPVC ASIA PACIFIC, VIT Vellore",
    year: "2016",
    right: false,
    img: "https://i.postimg.cc/02dz51H5/c6c2e9022f25f404fe108a4cfefab222.jpg",
    description:
      "Bluestreak 3.0, the team full of zeal took part in HPVC, ASIA PACIFIC 2016 at VIT, Vellore from 17-19th of March, 2016 and successfully marked its name in the trophy for being 2nd in the Design Event and overall 9th out of 31 teams.",
  },
  {
    id: "3",
    title: "HPVC ASIA PACIFIC, DTU Delhi",
    year: "2015",
    right: true,
    img: "https://i.postimg.cc/JzptJcL9/DTU-Delhi-official-logo.png",
    description:
      "Bluestreak 2.0, a 12 member team participated in HPVC, ASIA PACIFIC 2015 at DTU, Delhi held from January 16-18, 2015 and astound every single person present by securing 1st Rank in the technology innovation round.",
  },
  {
    id: "2",
    title: "University of Central Florida, Orlando",
    year: "2014",
    right: false,
    img: "https://i.postimg.cc/VN5vFrs5/Seal-of-the-University-of-Central-Florida-svg.png",
    description:
      "In 2014 team Bluestreak 1.1, a 3 member team from ASME@NITR, being the only team from Odisha and among the two teams from India, participated in the event at University of Central Florida, Orlando and had a brilliant standing as 31 out of 68 participants all over the world.",
  },
  {
    id: "1",
    title: "ASIA PACIFIC 2014, IIT DELHI",
    year: "2014",
    img: "https://i.postimg.cc/tCH1H4km/IIT-Delhi-logo.png",
    right: true,
    description:
      "Bluestreak 1.0, a team of 20 members represented ASME NITR in HPVC, ASIA PACIFIC 2014 at IIT Delhi and in its maiden attempt, the team put up an outstanding show securing the highest marks in Analysis Section and overall rank of 26th out of 52 teams in and outside India.",
  },
];

export const announcements = [
  "https://i.postimg.cc/j5pjzSLN/Whats-App-Image-2023-12-13-at-10-11-06-PM.jpg",
  "https://i.postimg.cc/T3fp71QJ/Whats-App-Image-2023-12-13-at-10-11-06-PM-1.jpg",
  "https://i.postimg.cc/vmSTZzy0/Whats-App-Image-2023-12-13-at-10-12-12-PM.jpg",
  "https://i.postimg.cc/htshHn5W/Whats-App-Image-2023-12-13-at-10-13-33-PM.jpg",
  "https://i.postimg.cc/3JMyGnv6/Whats-App-Image-2023-12-13-at-10-14-08-PM.jpg",
  "https://i.postimg.cc/hvmfw7Hp/Whats-App-Image-2023-12-13-at-10-15-41-PM.jpg",
  "https://i.postimg.cc/nr5tWr9M/Whats-App-Image-2023-12-13-at-11-15-23-AM.jpg",
];

export const quickStats = [
  { value: "2012", label: "Chapter founded" },
  { value: "4", label: "Core competition verticals" },
  { value: "8+", label: "International milestones" },
  { value: "100+", label: "Archived memories" },
];
